module.exports = __webpack_public_path__ + "static/14-73e9b43345d2b25e4420b47f2ebdf64f.jpg";